<div>
  <app-heading-small-component
    heading1="Empower Your administration with"
    heading2="seamless Efficency"
    heading3=""
    description="Streamline tasks, manage finances, and enhance communication—all from a single, secure platform."
    imageUrl="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/admin-staff-1.png"
  ></app-heading-small-component>
  <app-cards-wrap
    class="cards-wrap"
    heading1="Why administrations"
    heading2="love our"
    heading3="platform"
    heading4="!"
    subheading="See how you can benefit →"
    [array]="benifits"
  ></app-cards-wrap>
  <app-features-card class="features-card"></app-features-card>
</div>
